import { useEffect } from "react";
import useTranslator from "../../hooks/useTranslator";

// Message sent to the window that shows the KYC iframe.
export const KYC_FLOW_FINISHED_MESSAGE = "SKOR_KYC_FLOW_FINISHED";

// Didit redirects here (the session `callback`) when the user finishes the
// hosted verification. Inside the KYC iframe this page tells the parent page
// that the flow ended; the result itself comes from the backend webhook.
// Didit adds ?verificationSessionId=...&status=... to the URL.
const KycComplete = () => {
  const { _t } = useTranslator();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const message = {
      type: KYC_FLOW_FINISHED_MESSAGE,
      sessionId: params.get("verificationSessionId"),
      status: params.get("status"),
    };
    const target =
      window.parent !== window ? window.parent : window.opener || null;
    if (target) {
      target.postMessage(message, window.location.origin);
    }
  }, []);

  return (
    <div
      style={{ height: "100vh" }}
      className="dgboxsetup authenticateModal d-flex align-items-center justify-content-center"
    >
      <div className="text-center">
        <p>{_t("kycSuccess")}</p>
      </div>
    </div>
  );
};

export default KycComplete;
